import { ShiftOpportunityType } from '@amzn/atoz-shiftapp-types';
import { DateTime } from 'luxon';
export function matchVtoOpportunities(_a) {
    var shiftOpportunities = _a.shiftOpportunities, timeRange = _a.timeRange;
    if (!timeRange || !shiftOpportunities.length) {
        return [];
    }
    var vtoOpportunities = shiftOpportunities.filter(function (opportunity) {
        var _a, _b;
        var vtoStart = DateTime.fromISO(opportunity.shift.timeRange.start);
        var vtoEnd = DateTime.fromISO(opportunity.shift.timeRange.end);
        var shiftStart = DateTime.fromISO(timeRange.start);
        var shiftEnd = DateTime.fromISO(timeRange.end);
        var isEligible = !!((_a = opportunity.eligibility) === null || _a === void 0 ? void 0 : _a.isEligible);
        var isUnavailable = (((_b = opportunity.unavailability) === null || _b === void 0 ? void 0 : _b.reasons) || []).length > 0;
        return (opportunity.type === ShiftOpportunityType.VoluntaryTimeOff &&
            vtoStart >= shiftStart &&
            vtoEnd <= shiftEnd &&
            isEligible &&
            !isUnavailable);
    });
    return !!(vtoOpportunities === null || vtoOpportunities === void 0 ? void 0 : vtoOpportunities.length) ? vtoOpportunities : [];
}
